import { Control, Controller, FieldValues } from "react-hook-form";

import Select from "react-select";
import { Option } from "./AsyncAutocompleteSelect";

const customStyles = {
  container: (provided: any) => ({
    ...provided,
    width: "100%",
    minHeight: "40px",
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#f0f0f0" : "white",
    borderColor: state.isFocused ? "#007bff" : "#ccc",
    boxShadow: state.isFocused ? "0 0 5px rgba(0, 123, 255, 0.5)" : "none",
    "&:hover": {
      borderColor: "#007bff",
    },
    minHeight: "40px",
  }),
  option: (provided: any, state: any) => {
    const isFocusedColor = state.isFocused ? "#cce5ff" : "white";
    return {
      ...provided,
      backgroundColor: state.isSelected ? "#007bff" : isFocusedColor,
      color: state.isSelected ? "white" : "black",
      padding: 10,
    };
  },
  menu: (provided: any) => ({
    ...provided,
    borderRadius: "8px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  }),
  menuList: (provided: any) => ({
    ...provided,
  }),
};

interface Props {
  control: Control<FieldValues>;
  loading?: boolean;
  inputName: string;

  disabled?: boolean;
  items: Option[];
  multiple?: boolean;
}

export const AutocompleteSelect = ({
  control,
  inputName,
  disabled,
  loading,
  items,
  multiple = false,
}: Props) => {
  return (
    <Controller
      control={control}
      name={inputName}
      render={({ field }) => {
        return (
          <Select
            menuPlacement="top"
            isDisabled={loading || disabled}
            isLoading={loading}
            isClearable
            isSearchable
            isMulti={multiple}
            options={items}
            value={field.value}
            onChange={(e) => field.onChange(e)}
            onBlur={() => field.onBlur()}
            styles={customStyles}
          />
        );
      }}
    />
  );
};
